// FAQ.js (Updated)
import React from "react";
import "./faq.css";
import { Badge } from "react-bootstrap";

const FAQ = ({ faq, toggleFAQ, searchQuery }) => {

    // Function to highlight search terms in text
    const highlightText = (text) => {
        if (!searchQuery || !text) return text;

        const regex = new RegExp(`(${searchQuery})`, 'gi');
        const parts = text.split(regex);

        return parts.map((part, i) =>
            regex.test(part) ?
                <mark key={i} className="search-highlight">{part}</mark> :
                part
        );
    };

    // Function to format answer with line breaks
    const formatAnswer = (answer) => {
        if (!answer) return "";

        return answer.split('\n').map((line, i) => (
            <React.Fragment key={i}>
                {searchQuery ? highlightText(line) : line}
                <br />
            </React.Fragment>
        ));
    };

    return (
        <div
            className={`faq ${faq.open ? "open" : ""}`}
            key={faq._id}
            onClick={() => toggleFAQ(faq._id)}
        >
            <div className="faq-question">
                <div className="d-flex justify-content-between align-items-center">
                    <span className="question-text">
                        {searchQuery ? highlightText(faq.question) : faq.question}
                    </span>
                    <div className="d-flex gap-2">
                        {faq.category && (
                            <Badge bg="light" text="dark" className="category-badge">
                                {faq.category}
                            </Badge>
                        )}
                        <span className="toggle-icon">
                            {faq.open ? '−' : '+'}
                        </span>
                    </div>
                </div>
            </div>
            <div className="faq-answer">
                {formatAnswer(faq.answer)}

                {/* FAQ Stats */}
                <div className="faq-stats mt-3 pt-2 border-top">
                    <small className="text-muted">
                        <span className="me-3">
                            👍 {faq.helpfulCount || 0} helpful
                        </span>
                        <span className="me-3">
                            👎 {faq.notHelpfulCount || 0} not helpful
                        </span>
                        <span>
                            👁️ {faq.views || 0} views
                        </span>
                    </small>
                </div>
            </div>
        </div>
    );
};

export default FAQ;

// // FAQ.js (Updated with search highlight)
// import React from "react";
// import "./faq.css";
// import { Badge } from "react-bootstrap";

// const FAQ = ({ faq, index, toggleFAQ, searchQuery }) => {

//     // Function to highlight search terms in text
//     const highlightText = (text) => {
//         if (!searchQuery || !text) return text;

//         const regex = new RegExp(`(${searchQuery})`, 'gi');
//         const parts = text.split(regex);

//         return parts.map((part, i) =>
//             regex.test(part) ?
//                 <mark key={i} className="search-highlight">{part}</mark> :
//                 part
//         );
//     };

//     return (
//         <div
//             className={`faq ${faq.open ? "open" : ""}`}
//             key={index}
//             onClick={() => toggleFAQ(index)}
//         >
//             <div className="faq-question">
//                 <div className="d-flex justify-content-between align-items-center">
//                     <span className="question-text">
//                         {searchQuery ? highlightText(faq.question) : faq.question}
//                     </span>
//                     <div className="d-flex gap-2">
//                         {faq.category && (
//                             <Badge bg="light" text="dark" className="category-badge">
//                                 {faq.category}
//                             </Badge>
//                         )}
//                         <span className="toggle-icon">
//                             {faq.open ? '−' : '+'}
//                         </span>
//                     </div>
//                 </div>
//             </div>
//             <div className="faq-answer">
//                 {/* {formatAnswer(faq.answer)} */}
//                 {highlightText(faq.answer)}

//                 {/* FAQ Stats */}
//                 <div className="faq-stats mt-3 pt-2 border-top">
//                     <small className="text-muted">
//                         <span className="me-3">
//                             👍 {faq.helpfulCount || 0} helpful
//                         </span>
//                         <span className="me-3">
//                             👎 {faq.notHelpfulCount || 0} not helpful
//                         </span>
//                         <span>
//                             👁️ {faq.views || 0} views
//                         </span>
//                     </small>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default FAQ;

// import React from "react";
// import "./faq.css";

// const FAQ = ({ faq, index, toggleFAQ }) => {
//     return (
//         <div
//             className={"faq " + (faq.open ? "open" : "")}
//             key={index}
//             onClick={() => toggleFAQ(index)}
//         >
//             <div className="faq-question">{faq.question}</div>
//             <div className="faq-answer">{faq.answer}</div>
//         </div>
//     );
// };

// export default FAQ;
